import { HubFeature } from '@ats/api/cm';
import { LocDef, LocDefs, LocMap } from '@cm/core/localization';

const pathStart = 'System|Criteria|Rules|Add Criteria Rule|';
const sharedProperties: Pick<LocDef, 'shared' | 'htmlAllowed' | 'feature' | 'portal'> = {
	shared: false,
	htmlAllowed: false,
	feature: HubFeature.Core,
	portal: 'SP',
};

type LocNameStart = 'SPSystemCriteriaRulesAddCriteria';
export type SPSystemCriteriaRulesAddCriteriaLocNames =
	| `${LocNameStart}TitleAdd`
	| `${LocNameStart}ButtonCancel`
	| `${LocNameStart}ButtonSave`;

export const spSystemCriteriaRulesAddCriteriaLocs: LocDefs<SPSystemCriteriaRulesAddCriteriaLocNames> =
	{
		SPSystemCriteriaRulesAddCriteriaTitleAdd: {
			defaultValue: 'Add Criteria Rule',
			description: 'Add title',
			displayPath: `${pathStart}Title`,
			displayType: 'Title',
			legacyName: 'Announcements/Tools.AnnouncementCriteria.Title.AddRule',
			...sharedProperties,
		},
		SPSystemCriteriaRulesAddCriteriaButtonCancel: {
			defaultValue: 'Cancel',
			description: 'Cancel button',
			displayPath: `${pathStart}Cancel`,
			displayType: 'Button',
			...sharedProperties,
		},
		SPSystemCriteriaRulesAddCriteriaButtonSave: {
			defaultValue: 'Save',
			description: 'Save button',
			displayPath: `${pathStart}Save`,
			displayType: 'Button',
			...sharedProperties,
		},
	};

export type SPSystemCriteriaRulesAddCriteriaLocType =
	LocMap<SPSystemCriteriaRulesAddCriteriaLocNames>;
